import { apiCall, ApiResponse } from "./apiClient";
import { FormAnswerDto, FormAnswerSaveDto } from "../models/form/formAnswerDto";

export const saveFormAnswer = (
    dto: FormAnswerSaveDto
): Promise<ApiResponse<FormAnswerDto>> => {
    return apiCall<FormAnswerDto, FormAnswerSaveDto>(
        "FormAnswers",
        "POST",
        dto
    );
};
